import { gql } from 'graphql-request';

export const BING_ADS_QUERY = gql`
  query getAdsWebApp($videoReferenceId: String!, $timeStamp: String!) {
    getAds(videoReferenceId: $videoReferenceId, timeStamp: $timeStamp) {
      pageLoadPingUrl
      bingAds {
        id
        url
        impressionToken
        seller {
          name
          domain
        }
        price
        currency
        currencySymbol
        discountPrice
        impressionToken
        urlPingSuffix
        pingUrlBase
        visibilityFeedbackUrl
        itemOffered {
          name
          contentImageUrl
          description
        }
      }
    }
  }
`;
